<style lang="less" scoped>
.flagCard {position: relative;width: 320px;height: 820px;text-align: left;}
ul {list-style: none;width: 320px;}
li {float: left;margin-bottom: 5px;margin-right: 25px;}
.box{width: 120px;height: 126px;text-align: center;font-family: AlibabaPuHuiTi-Medium;font-size: 14px;font-weight: 600;margin-bottom: 8px;}
img {width: 112px;height: 76px;cursor: pointer;}
img:hover{opacity: .6;}
p{margin: 0px;font-size: 14px;}
</style>

<!-- 何宽 2021.6.10
     该卡片组件使用场景：左右两列整齐展示图片及图片名称。点击图片，将 相应的对象 传递给父组件 -->
<template>
  <ul>
    <li v-for="(item,index) in datalist" :key="index">
      <div class="box">
        <img :src="item.flag" @click="clickFlag(item)" />
        <p class="namec"> {{ item.namec }} </p>
        <p class="namee"> {{ item.namee }} </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data()
  {
    return {
      datalist: [
        {flag: 'static/images/zlkFlag/中国.png',       namec: '中国',      namee: 'CHINA',       value: 2},
        {flag: 'static/images/zlkFlag/马来西亚.png',   namec: '马来西亚',   namee: 'MALAYSIA',   value: 4},
        {flag: 'static/images/zlkFlag/印度尼西亚.png', namec: '印度尼西亚', namee: 'INDONESIA',   value: 3},
        {flag: 'static/images/zlkFlag/泰国.png',       namec: '泰国',      namee: 'THAILAND',    value: 7},
        {flag: 'static/images/zlkFlag/菲律宾.png',     namec: '菲律宾',     namee: 'PHILIPPINES', value: 5},
        {flag: 'static/images/zlkFlag/新加坡.png',     namec: '新加坡',     namee: 'SINGAPORE',   value: 6},
        {flag: 'static/images/zlkFlag/文莱.png',       namec: '文莱',      namee: 'BRUNEI',      value: 8},
        {flag: 'static/images/zlkFlag/越南.png',       namec: '越南',      namee: 'VIETNAM',     value: 9},
        {flag: 'static/images/zlkFlag/老挝.png',       namec: '老挝',      namee: 'LAOS',        value: 10},
        {flag: 'static/images/zlkFlag/缅甸.png',       namec: '缅甸',      namee: 'MYANMAR',     value: 11},
        {flag: 'static/images/zlkFlag/柬埔寨.png',     namec: '柬埔寨',     namee: 'CAMBODIA',   value: 12}
      ]
    }
  },
  methods: {
    // 点击国旗，将 相应的对象 传递给父组件
    clickFlag(item)
    {
      this.$emit('clickFlag', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/FlagCard.vue